import { SecurityDetails } from "../../simulations/models/securityDetails";
import { CModelRepo } from "../cmodel.repo";

class SecurityDetailsTableController {
  public securities: SecurityDetails[];
  public archive;
  public onEditSecurity: ({ security: securityDetails }) => {};
  public onDeleteSecurity: ({ security: securityDetails }) => {};
  public refreshSecurity: () => {};

  /** @ngInject */
  constructor(private cModelRepo: CModelRepo) {}

  public editSecurity(security: SecurityDetails) {
    this.onEditSecurity({ security });
  }

  public deleteSecurity(security: SecurityDetails) {
    this.onDeleteSecurity({ security });
  }

  public refreshSecurities() {
    this.refreshSecurity();
  }

  public archiveSecurities() {
    let selectedSecurities = this.securities.filter(
      (item) => item.temporaryCheck == true
    );
    this.cModelRepo
      .archiveSecurities(
        selectedSecurities.map((item) => item.id),
        this.archive
      )
      .then(() => this.refreshSecurities());
  }
}

export const SecurityDetailsTable: angular.IComponentOptions = {
  controller: SecurityDetailsTableController,
  template: require("./securityDetailTable.component.html"),
  bindings: {
    securities: "<",
    onEditSecurity: "&",
    onDeleteSecurity: "&",
    archive: "<",
    refreshSecurity: "&",
  },
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.securitymanagement/securityDetailTable.component.ts